import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IAllowedAclData } from "common/records/AllowedAclRecord";
import { IUserData } from "common/records/User";
import { List } from "immutable";

export const RECEIVE_USER = "@user/RECEIVE_USER";
export const RESET_USER = "@user/RESET_USER";
export const FETCH_CURRENT_USER = "@user/FETCH_CURRENT_USER";
export const SET_CURRENT_USER = "@user/SET_CURRENT_USER";
export const REMOVE_CURRENT_USER = "@user/REMOVE_CURRENT_USER";
export const FETCH_USER = "@user/FETCH_USER";
export const SET_USER_LOADED = "@user/SET_USER_LOADED";
export const RECEIVE_USERS = "@user/RECEIVE_USERS";
export const FETCH_ALLOWED_ACL = "@user/FETCH_ALLOWED_ACL";
export const RECEIVE_ALLOWED_ACL = "@user/RECEIVE_ALLOWED_ACL";
export const ADD_ACCESSES = "@user/ADD_ACCESSES";
export const UPDATE = "@user/UPDATE";
export const REMOVE = "@user/REMOVE";
export const CONCAT = "@user/CONCAT";
export const SET_CURRENT_USER_ERRORS = "@user/SET_CURRENT_USER_ERRORS";

export const UserActions = {
  receiveUser: (user: IUserData) => createAction(RECEIVE_USER, { user }),
  resetUser: (userId: number) => createAction(RESET_USER, { userId }),
  fetchCurrentUser: (email: string) => createAction(FETCH_CURRENT_USER, { email }),
  setCurrentUser: (user: Partial<IUserData>) => createAction(SET_CURRENT_USER, { user }),
  removeCurrentUser: () => createAction(REMOVE_CURRENT_USER),
  setCurrentUserErrors: (errors: string[]) => createAction(SET_CURRENT_USER_ERRORS, { errors }),
  fetchUser: (id: number) => createAction(FETCH_USER, id),
  setUserLoaded: (id: number) => createAction(SET_USER_LOADED, id),
  receiveUsers: (users: IUserData[]) => createAction(RECEIVE_USERS, users),
  receiveAllowedAcl: (userId: number, accessUid: string, template: string, allowedAcl: IAllowedAclData) =>
    createAction(RECEIVE_ALLOWED_ACL, { userId, accessUid, template, allowedAcl }),
  addAccesses: (userId: number, accessIds: number[]) => createAction(ADD_ACCESSES, { userId, accessIds }),
  update: (event: { path: (string | number)[]; name: string; value: any }) => createAction(UPDATE, event),
  remove: (event: { path: (string | number)[]; name: string; value: any }) => createAction(REMOVE, event),
  concat: (event: { path: (string | number)[]; name: string; value: List<any> }) => createAction(CONCAT, event),
};
export type UserActions = ActionsUnion<typeof UserActions>;
